  <div class="banner-slider-container" 
    [ngClass]="{'rounded-corners-12': callingfrom === this.mls.googleEventText.grandround.category}" 
    *ngIf="BannerObjData.classification!='upgrade' ">
     <div class="">
       <div class="item_banner text-center">
         <img loading="eager" fetchPriority="high" src="{{BannerObjData.file_url | fitInImg :igs.imageGroup.fitin_600x600}}" 
          (click)="bannerAction()" 
          [appAnalyticsEvent]="analyticsBannerData" 
          class="d-inline-block post-pic"
          [ngClass]="{'rounded-corners-12 banner-img': callingfrom === this.mls.googleEventText.grandround.category}"
          onError="this.src='assets/themes/images/banner-placeholder-lg.svg'">
       </div>
     </div>
   </div>
 
 <!-- get sample start -->
 <app-product-get-sample 
  *ngIf="isGetsampleModal==true" 
  (resetProductGetsampleModal)="resetProductGetsampleModal($event)" 
  [isGetsampleModal]="isGetsampleModal" 
  [JournalData]=BannerObjData 
  [product_type]=' ' 
  [product_type_id]=' ' 
  [drug_id]="BannerObjData.target_id">
</app-product-get-sample>
 <!-- get sample end -->